module.exports = __webpack_public_path__ + "img/電気回路_2_5_2.9d1ea198.png";